<template>
  <portal-layout>
    <div v-loading="loading" class="contact-page">
      <div class="page-head">
        <h2 class="page-title">联系老师</h2>
      </div>

      <div class="contact-card">
        <div v-if="!loading && !teacher.qrCode" class="empty-tip">暂未配置客服信息</div>

        <template v-if="teacher.qrCode">
          <div class="teacher-info">
            <img v-if="teacher.avatar" class="teacher-avatar" :src="teacher.avatar" :alt="teacher.name" />
            <div class="teacher-text">
              <div class="teacher-name">{{ teacher.name }}</div>
              <div class="teacher-meta">
                <span v-if="teacher.major">{{ teacher.major }}</span>
                <span v-if="teacher.education"> · {{ teacher.education }}</span>
              </div>
            </div>
          </div>

          <div class="qrcode-section">
            <div class="qrcode-title">扫码添加老师企业微信</div>
            <img class="qrcode-img" :src="teacher.qrCode" alt="客服二维码" />
            <div class="qrcode-tip">使用微信扫一扫添加</div>
          </div>

          <div class="contact-detail">
            <div v-if="teacher.mobile" class="detail-item">
              <i class="el-icon-phone"></i>
              <span>{{ teacher.mobile }}</span>
            </div>
            <div v-if="teacher.remark" class="detail-item">
              <i class="el-icon-info"></i>
              <span>{{ teacher.remark }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';

export default {
  name: 'PortalShopContact',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      teacher: {}
    }
  },
  created() {
    this.queryQrcode();
  },
  methods: {
    queryQrcode() {
      this.loading = true;
      api.customer_qrcode().then((r) => {
        if (r.data.code === "200" && r.data.data) {
          this.teacher = r.data.data;
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
<style scoped>
.contact-page {
  min-height: 300px;
}
.page-head {
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.contact-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 40px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  text-align: center;
}
.teacher-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 35px;
}
.teacher-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
}
.teacher-text {
  text-align: left;
}
.teacher-name {
  font-size: 19px;
  color: #303133;
  font-weight: 500;
}
.teacher-meta {
  font-size: 13px;
  color: #909399;
  margin-top: 6px;
}
.qrcode-section {
  margin-bottom: 35px;
}
.qrcode-title {
  font-size: 16px;
  color: #303133;
  margin-bottom: 20px;
}
.qrcode-img {
  width: 240px;
  height: 240px;
  object-fit: contain;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 10px;
  background-color: #fff;
}
.qrcode-tip {
  font-size: 13px;
  color: #909399;
  margin-top: 15px;
}
.contact-detail {
  display: inline-block;
  text-align: left;
  border-top: 1px solid #ebeef5;
  padding-top: 25px;
  min-width: 420px;
}
.detail-item {
  font-size: 14px;
  color: #606266;
  line-height: 30px;
}
.detail-item i {
  color: #409EFF;
  margin-right: 10px;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
}
</style>
